const extraFeaturesState = state => ({
  loading: state.extraFeatures.loading,
  error: state.extraFeatures.error,
  featureChecks: state.extraFeatures.featureChecks,
  featureSelect: state.extraFeatures.featureSelect,
  featureInputs: state.extraFeatures.featureInputs,
  originalFeatureChecks: state.extraFeatures.originalFeatureChecks,
  originalFeatureSelect: state.extraFeatures.originalFeatureSelect,
  originalFeatureInputs: state.extraFeatures.originalFeatureInputs,
  hasChanges: state.extraFeatures.hasChanges,
  minSuggestedFeatures: state.extraFeatures.minSuggestedFeatures,
  isEmpty: state.extraFeatures.isEmpty
});

const getCheckboxCategories = state => {
  const processedCategories = state.extraFeatures.processedCategories || {};
  return Object.entries(processedCategories)
    .filter(([id]) => id !== 'category-14')
    .map(([id, category]) => ({
      id,
      options: category.processedOptions || []
    }));
};

const getAdditionalCategories = state => {
  const processedCategories = state.extraFeatures.processedCategories || {};
  return processedCategories['category-14']?.processedOptions || [];
};

export { extraFeaturesState, getCheckboxCategories, getAdditionalCategories };
